import MainLayout from 'components/layouts/MainLayout';

export default function NotFound() {
  return (
    <MainLayout title="Not Found">
      <p className="ion-padding">Please go back and try again.</p>
    </MainLayout>
  );
};
